import { useState } from 'react';
import { AdminConsoleComponent } from '../components/Admin';
import { useAppContext } from '../Context';
import ComponentHeader from "./ComponentHeader";

const AdminConsolePage = () => {
  const items = [{ label: 'Admin Console', path: '/admin-console' }];
      const { providerType: contextProviderType, reviewYear: contextReviewYear } = useAppContext();
      const [localProviderType, setLocalProviderType] = useState<string>(contextProviderType);
      const [localReviewYear, setLocalReviewYear] = useState<number | undefined>(contextReviewYear);

  return (
    <div style={{ marginTop: '42px', marginBottom: '50px', marginLeft: '5px' }}>
      <ComponentHeader breadcrumbs={items} hideProviderTypeDropdown providerType={localProviderType} reviewYear={localReviewYear} onProviderTypeChange={setLocalProviderType} onReviewYearChange={setLocalReviewYear}/>
      <AdminConsoleComponent setLocalProviderType={setLocalProviderType} providerType={localProviderType} reviewYear={localReviewYear} />
    </div>
  );
};

export default AdminConsolePage;